import React from "react";
import { Link } from "react-router-dom";
import Advertise from "./Advertise";

function Calculators() {
  return (
    <section className="explore-section section-padding" id="section_2">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="mb-4">Explore Calculators</h2>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="design-tab-pane"
                role="tabpanel"
                aria-labelledby="design-tab"
                tabIndex="0"
              >
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/shipping-cost-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-truck"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Shipping Cost Calculator</h5>

                            <p className="mb-0">
                              Many shipping calculators also consider package dimensions, handling fees, and shipping speed (standard, express).
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/mortgage-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-house-chimney"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Mortgage Calculator</h5>

                            <p className="mb-0">
                              Calculates monthly payments based on loan amount, interest rate, and loan term.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/trip-spilt-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-car"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Trip Split Calculator</h5>

                            <p className="mb-0">
                                Calculates shared costs for trips, including accommodation, transportation, and meal expenses.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/carbon-foot-print-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-earth-americas"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Carbon Footprint Calculator</h5>

                            <p className="mb-0">
                              Estimates greenhouse gas emissions for individuals or businesses. Inputs can include energy consumption, transportation, and waste generation.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/income-tax-calculator">
                        <div className="fs-1 text-center">
                          <i className="fas fa-file-invoice-dollar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Income Tax Calculator</h5>

                            <p className="mb-0">
                              {" "}
                              Calculates personal or business income tax based
                              on income, deductions, and credits.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/return-on-investment-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-chart-line"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">ROI (Return on Investment) Calculator</h5>

                            <p className="mb-0">
                              Measures the profitability of investments,
                              factoring in net gains or losses.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <a href="/equated-monthly-installment-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-credit-card"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">EMI Calculator</h5>

                            <p className="mb-0">
                              Calculates monthly payment for loans, factoring in
                              principal, interest rate, and durations.
                            </p>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/body-mass-index-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-weight-scale"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Body Mass Index Calculator</h5>

                            <p className="mb-0">
                              Estimates body fat and categorizes health risk
                              based on weight and height.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/break-even-point-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-scale-balanced"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Break-Even Point Calculator</h5>

                            <p className="mb-0">
                              Calculates the sales volume needed to cover costs,
                              without profit or loss.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/loan-to-value-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-hand-holding-dollar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Loan-to-Value Calculator</h5>

                            <p className="mb-0">
                              Evaluates the risk associated with a loan relative
                              to the property value.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/fuel-cost-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-gas-pump"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Fuel Cost Calculator</h5>

                            <p className="mb-0">
                              Calculates fuel expenses based on distance,
                              vehicle efficiency, and fuel costs.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/time-value-money-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-clock"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">TVM (Time Value of Money) Calculator</h5>

                            <p className="mb-0">
                            Valuable for long-term financial planning.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/inventory-turnover-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-boxes-stacked"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Inventory Turnover Calculator</h5>

                            <p className="mb-0">
                            Measures the efficiency of inventory management over a period.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/depreciation-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-line-chart"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Depreciation Calculator</h5>

                            <p className="mb-0">
                            Calculates the loss in value of an asset over time, using various methods.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/payroll-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-dollar-sign"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Payroll Calculator</h5>

                            <p className="mb-0">
                            Calculates employee paychecks based on gross pay, deductions, taxes, and benefits.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/savings-goal-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-piggy-bank"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Savings Goal Calculator</h5>

                            <p className="mb-0">
                                Estimates how long it will take to reach a savings goal based on deposits, interest, and compounding frequency.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/retirement-calculator">
                        <div className="fs-1 text-center">
                        <i className="fa fa-briefcase"></i> + <i className="fa fa-dollar-sign"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Retirement Calculator</h5>

                            <p className="mb-0">
                                Projects retirement fund based on current savings, future contributions, and estimated return rates.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/markup-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-arrow-up"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Markup Calculator</h5>

                            <p className="mb-0">
                                Calculates the markup percentage needed to achieve a desired selling price based on cost.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/gpa-calculator">
                        <div className="fs-1 text-center">
                        <i className="fa fa-graduation-cap"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">GPA Calculator</h5>

                            <p className="mb-0">
                                Computes Grade Point Average by averaging grades with respective course credits.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/calories-burned-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-dumbbell"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Calories Burned Calculator</h5>

                            <p className="mb-0">
                                Estimates calories burned based on exercise type, weight, and duration.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/conversion-rate-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-percent"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Conversion Rate Calculator</h5>

                            <p className="mb-0">
                                Calculates the percentage of website visitors who complete a desired action.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/event-budget-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-money-bill-wave"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Event Budget Calculator</h5>

                            <p className="mb-0">
                                Estimates costs associated with organizing an event, factoring in different cost categories.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/lease-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-file-contract"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Lease Calculator</h5>

                            <p className="mb-0">
                                Calculates monthly lease payments for vehicles or equipment, based on initial cost, residual value, and interest rates.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/customer-lifetime-value-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-user"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Customer Lifetime Value (CLV) Calculator</h5>

                            <p className="mb-0">
                                Estimates the total revenue a business can expect from a customer over their lifetime.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/energy-cost-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-bolt"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Energy Cost Calculator</h5>

                            <p className="mb-0">
                                Calculates energy expenses based on appliance power ratings, usage duration, and electricity rates.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/compound-interest-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-dollar-sign"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Compound Interest Calculator</h5>

                            <p className="mb-0">
                                Calculates compound interest for investments, factoring in the frequency of compounding.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/inventory-cost-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-box"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Inventory Cost Calculator</h5>

                            <p className="mb-0">
                                Estimates the total cost of maintaining inventory, including purchase, storage, and ordering costs.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/project-cost-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-chart-bar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Project Cost Calculator</h5>

                            <p className="mb-0">
                                Estimates the total cost of a project based on labor, materials, and duration.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/pension-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-calculator"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Pension Calculator</h5>

                            <p className="mb-0">
                                Estimates retirement pension based on salary, service years, and retirement age.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/home-affordability-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-home"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Home Affordability Calculator</h5>

                            <p className="mb-0">
                                Calculates the maximum home price someone can afford based on income and debt.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/gross-profit-margin-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-chart-line"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Gross Profit Margin Calculator</h5>

                            <p className="mb-0">
                                Calculates the percentage of revenue exceeding the cost of goods sold.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/wedding-budget-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-gift"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Wedding Budget Calculator</h5>

                            <p className="mb-0">
                                Calculates the total expenses involved in planning a wedding.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/debt-to-income-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-balance-scale"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Debt-to-Income (DTI) Ratio Calculator</h5>

                            <p className="mb-0">
                                Measures monthly debt load in relation to income.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/freelance-hourly-rate-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-clock"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Freelance Hourly Rate Calculator</h5>

                            <p className="mb-0">
                                Estimates the hourly rate required to achieve a desired annual income.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/college-savings-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-graduation-cap"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">College Savings Calculator</h5>

                            <p className="mb-0">
                                Calculates the savings needed to cover college expenses, considering inflation.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/sales-tax-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-receipt"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Sales Tax Calculator</h5>

                            <p className="mb-0">
                                Calculates the total price of items after adding applicable sales tax.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/expense-ratio-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-chart-pie"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Expense Ratio Calculator</h5>

                            <p className="mb-0">
                                Calculates the annual operating expenses as a percentage of total assets under management.  
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>   

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/stock-profit-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-chart-line"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Stock Profit Calculator</h5>

                            <p className="mb-0">
                                Calculates the profit or loss from stock investments.  
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/running-pace-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-running"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Running Pace Calculator</h5>

                            <p className="mb-0">
                                Calculates running pace based on total time and distance run. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/operating-margin-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-chart-bar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Operating Margin Calculator</h5>

                            <p className="mb-0">
                                Calculates the profitability after accounting for operating expenses. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/body-fat-percentage-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-weight"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Body Fat Percentage Calculator</h5>

                            <p className="mb-0">
                                Estimates body fat percentage based on age, BMI, and gender. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/advertising-roi-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-bullseye"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Advertising ROI Calculator</h5>

                            <p className="mb-0">
                                Measures the return on investment for advertising campaigns. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/employee-turnover-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-users"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Employee Turnover Calculator</h5>

                            <p className="mb-0">
                                Calculates employee turnover rate for a specified period. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/productivity-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-rocket"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Productivity Calculator</h5>

                            <p className="mb-0">
                                Measures work efficiency based on output (e.g., units produced) relative to input (e.g., hours worked). 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/business-valuation-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-building"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Business Valuation Calculator</h5>

                            <p className="mb-0">
                                Estimates the market value of a business based on EBITDA (earnings before interest, tax, depreciation, and amortization) and industry multipliers. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/churn-rate-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-exclamation-circle"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Churn Rate Calculator</h5>

                            <p className="mb-0">
                                Measures the percentage of customers lost over a given period. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/yield-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-seedling"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Yield (Agriculture) Calculator</h5>

                            <p className="mb-0">
                                Calculates crop yield per unit area, aiding farmers in assessing productivity. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/markup-vs-margin-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-balance-scale"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Markup vs. Margin Calculator</h5>

                            <p className="mb-0">
                                Compares markup and margin percentages for pricing clarity. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/construction-material-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-tools"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Construction Material Calculator</h5>

                            <p className="mb-0">
                                Estimates the amount of material required for construction projects. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/return-on-assets-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-briefcase"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Return on Assets (ROA) Calculator</h5>

                            <p className="mb-0">
                                Measures how efficiently a company uses assets to generate profit. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/water-foot-print-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-tint"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Water Footprint Calculator</h5>

                            <p className="mb-0">
                                Estimates the total water used in producing a product or running a business. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/price-elasticity-demand-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-dollar-sign"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Price Elasticity of Demand Calculator</h5>

                            <p className="mb-0">
                                Measures how changes in price affect the demand for a product. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/loan-comparison-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-balance-scale"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Loan Comparison Calculator</h5>

                            <p className="mb-0">
                                Allows users to compare terms of multiple loans to choose the best option. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/work-in-progress-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-cogs"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Work-in-Progress (WIP) Calculator</h5>

                            <p className="mb-0">
                                Calculates the value of products in production that are not yet complete.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/employee-productivity-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-clock"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Employee Productivity Calculator</h5>

                            <p className="mb-0">
                                Measures employee output relative to input time. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/vehicle-depreciation-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-car"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Vehicle Depreciation Calculator</h5>

                            <p className="mb-0">
                                Calculates the depreciation of a vehicle over time. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/environmental-impact-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-globe"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Environmental Impact Calculator</h5>

                            <p className="mb-0">
                                Estimates a business or individual’s environmental footprint. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/profit-and-loss-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-chart-line"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Profit and Loss (P&L) Calculator</h5>

                            <p className="mb-0">
                                Calculates net profit or loss by subtracting expenses from revenue. 
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/cost-benefit-analysis-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-chart-bar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Cost-Benefit Analysis Calculator</h5>

                            <p className="mb-0">
                                Compares total benefits to costs to determine project feasibility.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/advertising-cost-per-impression-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-ad"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Advertising Cost Per Impression (CPM) Calculator</h5>

                            <p className="mb-0">
                                Calculates the cost of 1,000 impressions for advertising campaigns.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/land-valuation-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa fa-landmark"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Land Valuation Calculator</h5>

                            <p className="mb-0">
                                Estimates the value of a land parcel based on area and market rates.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/energy-efficiency-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-bolt"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Energy Efficiency Calculator</h5>

                            <p className="mb-0">
                                Calculates the energy efficiency of equipment or processes.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/days-sales-outstanding-calculator">
                        <div className="fs-1 text-center">
                           <i className="fa-solid fa-file-invoice-dollar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Days Sales Outstanding (DSO) Calculator</h5>

                            <p className="mb-0">
                                Measures the average number of days it takes a business to collect payments after a sale.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/employee-retention-rate-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-user-check"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Employee Retention Rate Calculator</h5>

                            <p className="mb-0">
                                Measures the percentage of employees a company retains over a period.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/order-fulfillment-cost-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-box"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Order Fulfillment Cost Calculator</h5>

                            <p className="mb-0">
                                Calculates the cost of fulfilling each order, including warehousing, packing, and shipping.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/safety-stock-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-dolly"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Safety Stock Calculator</h5>

                            <p className="mb-0">
                                Determines the optimal amount of extra inventory to keep on hand to prevent stockouts.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/defect-rate-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-times-circle"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Defect Rate Calculator</h5>

                            <p className="mb-0">
                                Measures the percentage of defective items in a production batch.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/burn-rate-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-fire"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Burn Rate (Startup) Calculator</h5>

                            <p className="mb-0">
                                Measures the rate at which a startup spends cash reserves.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/reorder-point-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-dolly-flatbed"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Reorder Point Calculator</h5>

                            <p className="mb-0">
                                Calculates the inventory level at which a new order should be placed.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/lead-scoring-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-filter"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Lead Scoring Calculator</h5>

                            <p className="mb-0">
                                Assesses the likelihood of a lead converting to a sale.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/employee-satisfaction-index-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-smile"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Employee Satisfaction Index Calculator</h5>

                            <p className="mb-0">
                                Measures employee satisfaction levels based on survey responses.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/overtime-pay-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-hourglass"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Overtime Pay Calculator</h5>

                            <p className="mb-0">
                                Calculates the total pay for overtime hours worked, often based on 1.5x or 2x regular pay.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/revenue-growth-rate-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-chart-line"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Revenue Growth Rate Calculator</h5>

                            <p className="mb-0">
                                Measures the growth rate of a company's revenue over time.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/profit-per-customer-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-user-tie"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Profit Per Customer Calculator</h5>

                            <p className="mb-0">
                                Calculates the average profit earned from each customer.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/equipment-downtime-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-gear"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Equipment Downtime Calculator</h5>

                            <p className="mb-0">
                                Measures the percentage of time equipment is unavailable due to breakdowns or maintenance.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/transportation-cost-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-shipping-fast"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Transportation Cost Calculator</h5>

                            <p className="mb-0">
                                Calculates the cost of transporting goods over a specified distance.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/net-promoter-score-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-poll"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Net Promoter Score (NPS) Calculator</h5>

                            <p className="mb-0">
                                Measures customer loyalty by gauging the likelihood of customers recommending a product/service.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/average-handle-time-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-stopwatch"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Average Handle Time (AHT) Calculator</h5>

                            <p className="mb-0">
                                Measures the average time taken to resolve a customer query or issue.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/weight-loss-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-weight"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Weight Loss Calculator</h5>

                            <p className="mb-0">
                                Provides an estimated timeline for achieving a weight-loss goal based on input data.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/patient-dosage-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-notes-medical"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Patient Dosage (Healthcare) Calculator</h5> 

                            <p className="mb-0">
                              Calculates accurate medication dosage based on patient weight or body surface area.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/lead-time-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-hourglass-half"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Lead Time Calculator</h5> 

                            <p className="mb-0">
                                Measures the total time required from placing an order to receiving the goods.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/rental-yield-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-house"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Rental Yield (Real Estate) Calculator</h5> 

                            <p className="mb-0">
                              Measures the annual return on a rental property as a percentage of its value.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/carbon-offset-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-recycle"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Carbon Offset Calculator</h5> 

                            <p className="mb-0">
                                Calculates the amount of carbon offsets needed to counteract a specific amount of emissions.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/cost-of-debt-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-file-invoice-dollar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Cost of Debt Calculator</h5> 

                            <p className="mb-0">
                                Calculates the effective rate a company pays on its borrowed funds.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/discounted-cash-flow-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-file-invoice-dollar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2"> Discounted Cash Flow (DCF) Calculator</h5> 
                            <p className="mb-0">
                              Determines the present value of future cash flows for investment decisions.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/cycle-time-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-industry"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Cycle Time (Manufacturing) Calculator</h5> 
                            <p className="mb-0">
                              Measures the time it takes to produce one unit from start to finish.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/project-payback-period-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-calendar"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Project Payback Period Calculator</h5> 
                            <p className="mb-0">
                                Calculates the time required to recover an initial investment.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/child-education-fund-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-child"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Child Education Fund Calculator</h5> 
                            <p className="mb-0">
                                Calculates the amount needed to save for a child’s education, considering inflation.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/breakdown-recovery-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-wrench"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Breakdown Recovery (Logistics) Calculator</h5> 
                            <p className="mb-0">
                                Estimates time required for a vehicle breakdown recovery.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/pension-fund-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-bank"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Pension Fund Calculator</h5> 
                            <p className="mb-0">
                              Estimates the total savings at retirement based on monthly contributions and interest.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/roi-for-marketing-campaigns-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-bullhorn"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">ROI for Marketing Campaigns Calculator</h5> 
                            <p className="mb-0">
                                Calculates the return on investment for marketing campaigns.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/weight-conversion-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-weight-scale"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Weight Conversion Calculator</h5> 
                            <p className="mb-0">
                              Converts units of weight between different measurement systems.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/cash-runway-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-wallet"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Cash Runway Calculator</h5> 
                            <p className="mb-0">
                                Measures how many months a company can operate before it runs out of cash.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/machine-downtime-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-cogs"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Machine Downtime Calculator</h5> 
                            <p className="mb-0">
                              Calculates how much time machinery is non-operational.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/overall-equipment-effectiveness-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-tachometer-alt"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Overall Equipment Effectiveness (OEE) Calculator</h5> 
                            <p className="mb-0">
                                Measures the efficiency of production equipment.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/production-cost-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-industry"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Production Cost Calculator</h5> 
                            <p className="mb-0">
                                Calculates the cost per unit in a production run.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/waste-percentage-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-trash"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Waste Percentage Calculator</h5> 
                            <p className="mb-0">
                                Determines the percentage of materials wasted in production.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/crop-yield-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-seedling"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Crop Yield Calculator</h5> 
                            <p className="mb-0">
                                  Estimates the productivity of a particular crop.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/water-usage-efficiency-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-faucet"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Water Usage Efficiency Calculator</h5> 
                            <p className="mb-0">
                              Measures how efficiently water is used for crop production.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/livestock-feed-cost-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-dollar-sign"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Livestock Feed Cost Calculator</h5> 
                            <p className="mb-0">
                                Calculates the per-unit cost of feeding livestock.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/fabric-consumption-calculator">
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-tshirt"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Fabric Consumption Calculator</h5> 
                            <p className="mb-0">
                                Estimates fabric consumption for garment production.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/thread-consumption-calculator">
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-ruler"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Thread Consumption Calculator</h5> 
                            <p className="mb-0">
                                Calculates the amount of thread required for a garment.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/cutting-waste-calculator">                      
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-scissors"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Cutting Waste Calculator</h5> 
                            <p className="mb-0">
                                Calculates fabric wasted during the cutting process.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/foot-traffic-calculator">                      
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-walking"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Foot Traffic Calculator</h5> 
                            <p className="mb-0">
                              Measures the average number of visitors in the mall.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/occupancy-cost-ratio-calculator">                      
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-building"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Occupancy Cost Ratio Calculator</h5> 
                            <p className="mb-0">
                             Assesses the cost of retail space as a percentage of sales revenue.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/customer-acquisition-cost-calculator">                      
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-shopping-bag"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Customer Acquisition Cost (CAC) Calculator</h5> 
                            <p className="mb-0">
                              Calculates the cost to acquire each new customer.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/cart-abandonment-rate-calculator">                      
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-right-from-bracket"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Cart Abandonment Rate Calculator</h5> 
                            <p className="mb-0">
                                Measures how often shoppers leave without purchasing.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  


                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/debt-service-coverage-ratio-calculator">                      
                        <div className="fs-1 text-center">
                            <i className="fa-solid fa-calculator"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Debt Service Coverage Ratio (DSCR) Calculator</h5> 
                            <p className="mb-0">
                              Evaluates the ability to cover debt obligations.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/travel-budget-calculator">                      
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-suitcase"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Travel Budget Calculator</h5> 
                            <p className="mb-0">
                              Calculates a comprehensive travel budget.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/flight-emission-calculator">                      
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-plane"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Flight Emission Calculator</h5> 
                            <p className="mb-0">
                            Calculates carbon footprint for flights.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/hotel-occupancy-rate-calculator">                      
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-hotel"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Hotel Occupancy Rate Calculator</h5> 
                            <p className="mb-0">
                              Measures hotel occupancy rates.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div className="custom-block bg-white shadow-lg">
                      <Link to="/tourist-spending-calculator">                      
                        <div className="fs-1 text-center">
                          <i className="fa-solid fa-globe"></i>
                        </div>
                        <div className="d-flex text-center">
                          <div className="ms-3">
                            <h5 className="mb-2">Tourist Spending Calculator</h5> 
                            <p className="mb-0">
                                Estimates average spending per tourist.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <Advertise 
            adClient="ca-pub-8380106160291700"
            adSlot="4666872877" 
          />
        </div>
      </div>
    </section>
  );
}

export default Calculators;
